var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilHex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.59277,
    y: 65.2368,
    width: 18.3455,
    height: 6.10243,
    rx: 3.05121,
    fill: "#F05C5B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37.147,
    y: 65.2368,
    width: 18.3455,
    height: 6.10243,
    rx: 3.05121,
    fill: "#F05C5B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99627 35.9535C0.892116 34.0051 0.892115 31.62 1.99627 29.6716L14.2516 8.04543C15.3828 6.04929 17.4999 4.81559 19.7943 4.81559L44.1006 4.81559C46.395 4.81559 48.5122 6.04929 49.6433 8.04542L61.8986 29.6715C63.0028 31.62 63.0028 34.0051 61.8986 35.9535L49.6433 57.5797C48.5122 59.5758 46.395 60.8095 44.1006 60.8095L19.7943 60.8095C17.4999 60.8095 15.3828 59.5758 14.2516 57.5797L1.99627 35.9535Z",
    fill: "#F05C5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9514 40.0478C39.0097 40.0478 44.7315 34.211 44.7315 27.011C44.7315 19.8109 39.0097 13.9741 31.9514 13.9741C24.8932 13.9741 19.1714 19.8109 19.1714 27.011C19.1714 34.211 24.8932 40.0478 31.9514 40.0478Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1087 32.7353C32.6488 32.7353 35.5186 29.8442 35.5186 26.2778C35.5186 22.7114 32.6488 19.8203 29.1087 19.8203C25.5686 19.8203 22.6987 22.7114 22.6987 26.2778C22.6987 29.8442 25.5686 32.7353 29.1087 32.7353Z",
    fill: "#570029"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4997 31.634L56.8789 26.1504L42.4314 52.5244L52.0522 58.008L66.4997 31.634Z",
    fill: "#371616"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0783 54.9945C40.4227 56.1913 40.8523 57.7093 42.0379 58.3851L47.3653 61.4216C48.5509 62.0974 50.0434 61.675 50.699 60.4782L52.0522 58.008L42.4314 52.5244L41.0783 54.9945Z",
    fill: "#782E2E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5002 31.6338L66.4546 23.8812L63.1836 22.0167L56.8794 26.1501L66.5002 31.6338Z",
    fill: "#FFEEED"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5078 22.7013C66.5619 21.5002 65.2646 20.7186 64.2586 21.3462L63.1836 22.0167L66.4546 23.8812L66.5078 22.7013Z",
    fill: "#371616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilHex);
export default __webpack_public_path__ + "static/media/pencil-hex.8d5fe5dca93b8e57593d4b55235b0835.svg";
export { ForwardRef as ReactComponent };